import { render, staticRenderFns } from "./SectionSettingsTab.vue?vue&type=template&id=34645360&scoped=true&"
import script from "./SectionSettingsTab.vue?vue&type=script&lang=ts&"
export * from "./SectionSettingsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34645360",
  null
  
)

export default component.exports